<div>
    <div>
        <h2>Facility Config</h2>
        <table>
            <thead>
                <tr>
                    <th>Facility Name</th>
                    <th>Facility Code</th>
                    <th>Prov</th>
                    <th>Region</th>
                    <th>Owner Active</th>
                    <th>AD Active</th>
                    <th>AD Model</th>
                    <th>AD File Name</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let facility of facilitySettings">
                    <td>{{facility.name}}</td>
                    <td>{{facility.facility_code}}</td>
                    <td>{{facility.prov}}</td>
                    <td>{{facility.regionId}}</td>
                    <td>{{facility.ownerActive}}</td>
                    <td><input type="checkbox" [checked]="facility.advancedDirectiveEnabled" (change)="updateFacilityConfig(facility, 'advancedDirectiveEnabled', $event.target.checked)" /></td>
                    <td><input type="text" [value]="facility.advancedDirectiveModel || ''" (change)="updateFacilityConfig(facility, 'advancedDirectiveModel', $event.target.value)" /></td>
                    <td><input type="text" [value]="facility.advancedDirectiveFileName || ''" (change)="updateFacilityConfig(facility, 'advancedDirectiveFileName', $event.target.value)" /></td>
                </tr>
            </tbody>
        </table>
    </div>
</div>